import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeVasActionAsync } from '../redux/actions/typeVasAction'

export const useTypeVas = () => {
  const { typeVasState } = useSelector((state: RootState) => state.typeVas)

  const dispatch = useDispatch()

  const getTypeVas = () => {
    dispatch(getTypeVasActionAsync())
  }

  return { typeVasState, getTypeVas }
}
